import { render, staticRenderFns } from "./add-contact.vue?vue&type=template&id=07b7d514"
import script from "./add-contact.vue?vue&type=script&lang=ts"
export * from "./add-contact.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports